import dayjs from 'dayjs'

import { WHOLESALE_STATUS_TITLE } from '@grid/columns/main/WholesaleOrderColumn'
import { OrderType } from '@schemas'

/**
 * Wholesale Orders 의 화면 · 엑셀 · PDF 가 같이 쓰는 표기 — 한 곳에서 정해야 셋이 어긋나지 않는다.
 */

/** 금액 — KRW 는 원 단위 정수, 그 밖은 소수 둘째 자리 */
export const wholesaleMoney = (currency: string, value: number): string =>
	currency === 'KRW'
		? `₩${Math.round(value).toLocaleString('ko-KR')}`
		: `$${value.toLocaleString('en-US', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2,
		  })}`

/** 상태 — 주문확인 뒤 아직 입금 전이면 배송 상태 옆에 Unpaid (DISPATCH_PLAN, 2026-09-27) */
export const wholesaleStatusTitle = (order: OrderType): string => {
	const title = WHOLESALE_STATUS_TITLE[order.status] ?? order.status
	const isUnpaid =
		order.paidYn === 0 &&
		!['awaitingPayment', 'deleted', 'refunded'].includes(order.status)
	return isUnpaid ? `${title} · Unpaid` : title
}

/** 받는 곳 한 줄 — 빈 칸과 옛 데이터의 'undefined' 문자열은 건너뛴다 */
export const wholesaleAddress = (order: OrderType): string =>
	[order.address1, order.address2, order.city, order.state, order.zip, order.country]
		.filter(
			aPart =>
				aPart !== undefined &&
				aPart !== null &&
				!['', 'undefined'].includes(String(aPart)),
		)
		.join(', ')

export const wholesaleDate = (value: string): string =>
	value ? dayjs(value).format('MMM DD YYYY') : ''

export const wholesaleDateTime = (value: string): string =>
	value ? dayjs(value).format('MMM DD YYYY · HH:mm') : ''

/** 운송장이 붙었는가 — 빈 문자열 · null 모두 없음 */
export const hasWholesaleShipment = (order: OrderType): boolean =>
	(order.trackingNumber ?? '') !== ''
